function SvgSend(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' {...props}>
      <path d='M4.4 19.525q-.55.25-1.062-.087-.513-.338-.513-.963V15.05q0-.4.225-.713.225-.312.6-.387L11.1 12l-7.45-1.95q-.375-.075-.6-.388-.225-.312-.225-.712V5.525q0-.625.513-.963.512-.337 1.062-.087l15.35 6.475q.7.3.7 1.05t-.7 1.05z' />
    </svg>
  )
}

export default SvgSend
